import { type GameApp } from '@app-types/api/auth'

interface GameSwitcherAppItemProps {
  app: GameApp
  isCurrent: boolean
  onClose: () => void
}

function GameSwitcherAppItem({
  app,
  isCurrent,
  onClose,
}: GameSwitcherAppItemProps) {
  return (
    <li>
      <a
        className={`grid min-w-0 rounded-md px-3 py-2 text-sm font-semibold no-underline transition ${
          isCurrent
            ? 'bg-violet-50 text-violet-800 dark:bg-violet-950/40 dark:text-violet-200'
            : 'text-slate-700 hover:bg-slate-100 hover:text-slate-950 dark:text-slate-200 dark:hover:bg-zinc-800 dark:hover:text-white'
        }`}
        href={app.url}
        onClick={onClose}
      >
        <span className="min-w-0 truncate">{app.name}</span>
        <span className="mt-0.5 min-w-0 truncate text-[11px] leading-4 font-medium text-slate-500 dark:text-slate-400">
          {app.slug}
        </span>
      </a>
    </li>
  )
}

export default GameSwitcherAppItem
